var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupDiscussionMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 46.6666C29.9999 51.2708 26.2708 54.9999 21.6666 54.9999C17.0624 54.9999 13.3333 51.2708 13.3333 46.6666C13.3333 42.0624 17.0624 38.3333 21.6666 38.3333C26.2708 38.3333 29.9999 42.0624 29.9999 46.6666Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 67.2221C5 61.3111 16.1042 58.3333 21.6667 58.3333C27.2292 58.3333 38.3333 61.3111 38.3333 67.2221V71.6666H5V67.2221Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 46.6666C66.6667 51.2708 62.9375 54.9999 58.3333 54.9999C53.7292 54.9999 50 51.2708 50 46.6666C50 42.0624 53.7292 38.3333 58.3333 38.3333C62.9375 38.3333 66.6667 42.0624 66.6667 46.6666Z",
    fill: "#6F6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6666 44.9999C46.6666 48.6833 43.6833 51.6666 39.9999 51.6666C36.3166 51.6666 33.3333 48.6833 33.3333 44.9999C33.3333 41.3166 36.3166 38.3333 39.9999 38.3333C43.6833 38.3333 46.6666 41.3166 46.6666 44.9999Z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 67.2221C41.6667 61.3111 52.7709 58.3333 58.3334 58.3333C63.8959 58.3333 75.0001 61.3111 75.0001 67.2221V71.6666H41.6667V67.2221Z",
    fill: "#6F6F6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.918 56.975C47.4731 57.1385 47.0343 57.3122 46.6041 57.4958C44.6523 58.33 42.6813 59.4568 41.15 60.9642C40.74 61.368 40.3508 61.8107 40 62.2917C39.6491 61.8107 39.26 61.368 38.8498 60.9642C37.3186 59.4568 35.3475 58.33 33.3956 57.4958C32.9656 57.3122 32.5268 57.1385 32.0818 56.975C34.6195 55.6602 37.883 55 40 55C42.1168 55 45.3803 55.6602 47.918 56.975Z",
    fill: "#6F6F6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.823 30C40.5675 30 47.6563 24.4035 47.6563 17.5C47.6563 10.5964 40.5675 5 31.823 5C23.0785 5 15.9897 10.5964 15.9897 17.5C15.9897 19.177 16.408 20.7768 17.1667 22.238C15.4909 24.292 15.0805 27.4018 15.0007 29.3565C14.9717 30.0678 15.8306 30.4317 16.4009 30.0055C17.5447 29.1507 19.3612 27.9913 21.7208 27.1255C24.4622 28.9208 27.983 30 31.823 30Z",
    fill: "#6F6F6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9451 29.7758C48.2539 26.8724 51.0056 22.4516 51.0056 17.4999C51.0056 16.1678 50.8064 14.874 50.4314 13.6379C51.4149 13.439 52.4447 13.3333 53.5056 13.3333C60.4091 13.3333 66.0056 17.8104 66.0056 23.3333C66.0056 24.9139 65.5472 26.4088 64.7309 27.7378C65.5017 29.0434 65.7757 30.6806 65.8647 31.9124C65.9159 32.6224 65.0566 32.9948 64.4731 32.5868C63.7509 32.0818 62.7674 31.4881 61.5602 30.9807C59.3847 32.4486 56.5742 33.3333 53.5056 33.3333C49.6701 33.3333 46.2379 31.9513 43.9451 29.7758Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDiscussionMeeting);
export default __webpack_public_path__ + "static/media/group-discussion-meeting.99f0a323ea12b364f14de0c23a8468e9.svg";
export { ForwardRef as ReactComponent };